import {Utils} from "./Utils";

class InfieldLabel {
  private el: HTMLElement;
  private input: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null = null;
  private static defaultOptions = {
    focusClass: 'c-form__fieldwrap--placeholder-focus',
    hideClass: 'c-form__fieldwrap--placeholder-hide',
  };
  private options: typeof InfieldLabel.defaultOptions;

  constructor(el: HTMLElement, options: Partial<typeof InfieldLabel.defaultOptions>) {
    this.el = el;
    this.options = { ...InfieldLabel.defaultOptions, ...options };
    this.setup();
    this.bind();
  }

  private setup() {
    this.input = this.el.querySelector('input, textarea, select');
    this.blur();
  }

  private bind() {
    if (this.input) {
      this.input.addEventListener('focus', () => {
        this.el.classList.remove(this.options.hideClass);
        this.el.classList.add(this.options.focusClass);
      });

      this.input.addEventListener('blur', () => this.blur());
      this.input.addEventListener('change', () => this.blur());
    }
  }

  private blur() {
    if (this.input) {
      if (this.input.value !== '') {
        this.el.classList.remove(this.options.focusClass);
        this.el.classList.add(this.options.hideClass);
      } else {
        this.el.classList.remove(this.options.focusClass, this.options.hideClass);
      }
    }
  }
}

Utils.executeWhenDocumentIsReady(  () => {
  const elements = document.querySelectorAll<HTMLElement>('[data-infieldLabel]');
  elements.forEach((element) => new InfieldLabel(element, {}));
});
